import { render, staticRenderFns } from "./TechText.vue?vue&type=template&id=131779d7&scoped=true&"
import script from "./TechText.vue?vue&type=script&lang=js&"
export * from "./TechText.vue?vue&type=script&lang=js&"
import style0 from "./TechText.vue?vue&type=style&index=0&id=131779d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131779d7",
  null
  
)

export default component.exports